import { SVGProps } from 'react';

const ServerCog = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m10.852 14.772-.383.923m4.303-2.547a3 3 0 0 1-3.92 1.624m0 0a3 3 0 0 1-1.624-1.624m3.92 1.624.382.924m1.242-2.548a3 3 0 0 0 0-2.296m0 2.296.923.383m-.923-2.68a3 3 0 0 0-1.624-1.623m1.624 1.624.923-.383m-6.467.383a3 3 0 0 1 3.92-1.624m0 0 .383-.923m-2.679.923-.383-.923m-1.241 4.843a3 3 0 0 1 0-2.296m0 2.296-.923.383m.923-2.68-.923-.382M4.5 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-.5m-15 4H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-.5M6 18h.01M6 6h.01"
    />
  </svg>
);
export default ServerCog;
